import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { CSSGeneratePadding, CSSGenerateMargin } from '../styles/cssGenerate.js';
import { getColor } from '../styles/stylePropTypes.js';

const BORDER_RADIUS_REM = {
    small: 0.25,
    medium: 0.5,
    large: 0.75,
    xlarge: 1,
    circle: 999
};
const BoxWrapper = styled.div`
  display: flex;
  ${(props)=>props.bgColor && `background-color: ${getColor(props.bgColor, props.theme)}`};
  ${(props)=>props.padding !== undefined ? CSSGeneratePadding(props.padding) : ""}
  ${(props)=>props.margin !== undefined ? CSSGenerateMargin(props.margin) : ""}
  ${(props)=>props.height === "fill" && "height: 100%;"}
  ${(props)=>props.width === "fill" && "width: 100%;"}
  ${(props)=>!isNaN(Number(props.minHeight)) && `min-height: ${props.minHeight}rem;`}
  ${(props)=>!isNaN(Number(props.minWidth)) && `min-width: ${props.minWidth}rem;`}
  ${(props)=>!isNaN(Number(props.maxHeight)) && `max-height: ${props.maxHeight}rem;`}
  ${(props)=>!isNaN(Number(props.maxWidth)) && `max-width: ${props.maxWidth}rem;`}
  ${(props)=>props.border !== "none" && `border: 1px ${props.border} ${props.borderColor ? getColor(props.borderColor, props.theme) : COLOR_PALETTE.slateGrey60};`}
  ${(props)=>props.borderRadius && `border-radius: ${BORDER_RADIUS_REM[props.borderRadius]}rem;`}
  overflow: ${(props)=>props.overflow === "scroll" ? "auto" : props.overflow};
  ${(props)=>props.flexGrow !== undefined && `flex-grow: ${props.flexGrow}`}
`;
/**
 * Layout component for creating padding (and margins). Makes other componentry more composable by
 * removing layout spacing (padding) from other components.
 *
 * Can also be used as a containing element
 *
 * @param padding - tuple of padding top/bottom & left/right values (in rem) or single value padding for all sides.
 * @param margin - tuple of margin top/bottom & left/right values (in rem) or single value margin for all sides.
 *
 * @example
 * <Box padding={[0,1]} margin={[1,1]}>
 *  <SomeElement />
 *  <SomeElement />
 * </Box>
 */ const Box = // eslint-disable-next-line react/display-name
forwardRef((props, ref)=>React__default.createElement(BoxWithRef, {
        ...props,
        forwardedRef: ref
    }));
Box.dataId = "data-hpy-web-box";
Box.displayName = "Box";
const BoxWithRef = ({ border ="none" , overflow ="visible" , as , forwardedRef , children , ...props })=>{
    return React__default.createElement(BoxWrapper, {
        "data-hpy-web-box": true,
        ...props,
        ref: forwardedRef,
        forwardedAs: as,
        border: border,
        overflow: overflow
    }, children);
};
BoxWithRef.dataId = "data-hpy-web-box";
BoxWithRef.displayName = "Box";

export { Box };
